import React, { useState } from 'react';
import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/solid';
import Button from './Button';
import api from '../services/api';

const PaymentSettings = ({ shop, onUpdate }) => {
  const [formData, setFormData] = useState({
    stripe: {
      publicKey: shop.paymentSettings?.stripe?.publicKey || '',
      secretKey: '',
    },
    payByLink: {
      apiKey: '',
      apiSecret: '',
    },
  });
  const [status, setStatus] = useState({ success: false, error: false, message: '' });

  const onChange = (e) => {
    const { name, value } = e.target;
    const [provider, key] = name.split('.');
    setFormData((prev) => ({
      ...prev,
      [provider]: {
        ...prev[provider],
        [key]: value,
      },
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ success: false, error: false, message: '' });
    try {
      const res = await api.put(`/shops/${shop._id}`, {
        paymentSettings: formData,
      });
      onUpdate(res.data);
      setStatus({ success: true, message: 'Ustawienia płatności zaktualizowane!' });
    } catch (err) {
      console.error(err);
      setStatus({ error: true, message: 'Błąd podczas aktualizacji ustawień.' });
    }
  };

  return (
    <div className="mt-8 p-6 bg-gray-800 border border-gray-700 rounded-lg shadow-lg">
      <h2 className="text-3xl font-bold mb-6 text-white">Ustawienia Płatności</h2>
      <form onSubmit={onSubmit} className="space-y-6">
        <div>
          <h3 className="text-2xl font-semibold text-indigo-400 mb-4">Stripe</h3>
          <div className="space-y-4">
            <input
              type="text"
              name="stripe.publicKey"
              value={formData.stripe.publicKey}
              onChange={onChange}
              placeholder="Klucz publiczny Stripe"
              className="w-full p-3 bg-gray-700 text-white rounded-md border border-gray-600 focus:ring-2 focus:ring-indigo-500"
            />
            <input
              type="password"
              name="stripe.secretKey"
              value={formData.stripe.secretKey}
              onChange={onChange}
              placeholder="Zmień klucz prywatny Stripe (pozostaw puste, aby nie zmieniać)"
              className="w-full p-3 bg-gray-700 text-white rounded-md border border-gray-600 focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        </div>
        <div>
          <h3 className="text-2xl font-semibold text-green-400 mb-4">PayByLink</h3>
          <div className="space-y-4">
            <input
              type="password"
              name="payByLink.apiKey"
              value={formData.payByLink.apiKey}
              onChange={onChange}
              placeholder="Nowy klucz API PayByLink (pozostaw puste, aby nie zmieniać)"
              className="w-full p-3 bg-gray-700 text-white rounded-md border border-gray-600 focus:ring-2 focus:ring-green-500"
            />
            <input
              type="password"
              name="payByLink.apiSecret"
              value={formData.payByLink.apiSecret}
              onChange={onChange}
              placeholder="Nowy sekret API PayByLink (pozostaw puste, aby nie zmieniać)"
              className="w-full p-3 bg-gray-700 text-white rounded-md border border-gray-600 focus:ring-2 focus:ring-green-500"
            />
          </div>
        </div>
        <div className="flex items-center justify-between">
          <Button type="submit" className="bg-indigo-600 hover:bg-indigo-700">
            Zapisz Ustawienia
          </Button>
          {status.success && (
            <div className="flex items-center text-green-400">
              <CheckCircleIcon className="h-5 w-5 mr-2" />
              <span>{status.message}</span>
            </div>
          )}
          {status.error && (
            <div className="flex items-center text-red-400">
              <ExclamationCircleIcon className="h-5 w-5 mr-2" />
              <span>{status.message}</span>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default PaymentSettings;